/**
 * React component that renders nav breadcrumbs under the navbar
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
// Don't render breadcrumbs for non authenticated users
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Nav, NavItem } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'client/shared/js/components/Link'
import styles from './BreadCrumbs.module.scss'

const BreadCrumbs = ({
  navLinks
}) => {
  let navItems = []

  navLinks.forEach((navLink, index) => {
    const { title, link } = navLink

    // Create separator
    navItems.push(
      <NavItem className={cx(styles['breadcrumb-separator'])} key={`breadcrumb-separator-${title}`}>
        <FontAwesomeIcon icon={['fal', 'angle-right']} />
      </NavItem>
    )

    const NavLinkTitle = (link && link.to) ? (
      <Link {...link}>{title}</Link>
    ) : title

    navItems.push(
      <NavItem className='breadcrumb-link' key={`breadcrumb-link-${index}`}>
        {NavLinkTitle}
      </NavItem>
    )
  })

  return (navItems.length > 0) ? (
    <div className={cx(styles['breadcrumbs-container'])}>
      <Nav className={cx(styles['breadcrumbs-nav'])}>
        <NavItem className={cx(styles['breadcrumb-link'])}>
          <Link to='/home'>Home</Link>
        </NavItem>
        {navItems}
      </Nav>
    </div>
  ) : null
}

BreadCrumbs.defaultProps = {
  navLinks: []
}

BreadCrumbs.propTypes = {
  navLinks: PropTypes.array
}

export default BreadCrumbs
